import { IconType } from 'record-it-components/misc/IconDeprecated/IconDeprecated';
export class IconUtils {
  private constructor() {}
  public static thinner<T extends AnyIconConfiguration>(config: T): T {
    if (this.isUnprefixedIconConfiguration(config)) {
      return {
        ...config,
        type: this.getThinnerIconType(config.type)
      };
    }
    return {
      ...config,
      iconType: this.getThinnerIconType(config.iconType)
    };
  }
  public static prefixConfigurations<T extends IconConfigurationConstraint<IconConfiguration>>(configurations: Readonly<T>): ReplaceIconConfigurationWithPrefixedVersionDeep<T> {
    const prefixed: IconConfigurationConstraint<PrefixedIconConfiguration> = {};
    const entries = Object.entries(configurations) as Array<[keyof T, Record<string, IconConfiguration>]>;
    for (const [categoryOrConfigName, categoryOrConfig] of entries) {
      if (this.isUnprefixedIconConfiguration(categoryOrConfig)) {
        prefixed[categoryOrConfigName as string] = {
          iconName: categoryOrConfig.name,
          iconType: categoryOrConfig.type
        };
      } else {
        prefixed[categoryOrConfigName as string] = this.prefixConfigurations(categoryOrConfig);
      }
    }
    return prefixed as any;
  }
  private static isUnprefixedIconConfiguration(config: Record<string, unknown>): config is IconConfiguration {
    return 'name' in config && 'type' in config && typeof config.name === 'string' && typeof config.type === 'string';
  }
  private static getThinnerIconType(type: IconType): IconType {
    switch (type) {
      case IconType.Solid:
        return IconType.Regular;
      case IconType.Regular:
        return IconType.Light;
      case IconType.Light:
        return IconType.Light;
      default:
        throw new Error(`unhandled iconType "${type}"`);
    }
  }
}
export type IconConfiguration = {
  name: string;
  type: IconType;
};
export type PrefixedIconConfiguration = {
  iconName: string;
  iconType: IconType;
};
export type AnyIconConfiguration = IconConfiguration | PrefixedIconConfiguration;
export type IconConfigurationConstraint<TIconConfiguration> = TIconConfiguration | {
  [key: string]: IconConfigurationConstraint<TIconConfiguration>;
};
export type ReplaceIconConfigurationWithPrefixedVersionDeep<T> = { [key in keyof T]: T[key] extends IconConfiguration ? PrefixedIconConfiguration : T[key] extends Record<string, unknown> ? ReplaceIconConfigurationWithPrefixedVersionDeep<T[key]> : never };